import { render, staticRenderFns } from "./order-view-client-existing.vue?vue&type=template&id=5f3e9524&scoped=true&"
import script from "./order-view-client-existing.ts?vue&type=script&lang=ts&"
export * from "./order-view-client-existing.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3e9524",
  null
  
)

export default component.exports